import { IWizardInitialState } from "./WizardReducer.types";
import {
  standardFormWizardOptions,
  elevenYearFormWizardOptions,
  disabilityApprovedFormWizardOptions,
} from "./MemberWizard";
import { PaymentAttemptStatusEnum } from "../../utils/enums/paymentAttemptStatusEnum";

export const wizardReducerInitialState: IWizardInitialState = {
  attestProduction: false,
  companyAdminImpersonated: false,
  companyPreProvidedData: true,
  completedRenewalMembership: false,
  currentPage: 0,
  currentStep: "",
  disabilityApprovedFormWizardOptions,
  elevenYearFormWizardOptions,
  errorPage: { messageHeader: "", messageText: "", show: false },
  flyoutObject: {
    buttonText: "",
    display: false,
    levelImgSrc: "",
    notificationText: "",
  },
  formOptions: [],
  furthestCompletedPage: 0,
  gettingStarted: {
    answers: {
      disabilityQuestion: null,
      ethicalQuestion: null,
      professionalAssociationQuestion: null,
    },
  },
  gettingStartedPageVisited: false,
  greetingPageVisited: false,
  isProfileValid: false,
  membershipLevel: {
    beforeUpgradeMembershipLevel: "",
    qualifiedMembershipLevel: "",
    selectedMembershipLevel: "",
  },
  membershipType: "Qualifying Member",
  membershipTypePageVisited: false,
  newMemberResponse: { isNewMember: false },
  pages: [],
  paymentMethod: null,
  paymentStatus: PaymentAttemptStatusEnum.NotAttempted,
  productionPageVisited: false,
  progressOptions: [],
  qualifyingMethod: null,
  redirectResult: null,
  reviewPageVisited: false,
  showPaymentPage: false,
  showProfilePage: true,
  showRoutingPage: false,
  skipMembershipTypeAndProduction: false,
  skipProductionPage: false,
  standardFormWizardOptions,
  termsAndConditionsAccepted: false,
  totWaiverUsed: false,
  totalCostToPay: {
    backDues: 0,
    baseMembershipCost: 0,
    lateFees: 0,
    membershipLevelCost: 0,
    total: null,
  },
  totalNumberOfUploadedDocuments: 0,
  upgrade: false,
  uploadedDocumentNames: [],
  userAgreedToPayBackdues: false,
  userAttestedProduction: false,
};

export default {};
